import { render, staticRenderFns } from "./videoCenter.vue?vue&type=template&id=c2705732&scoped=true"
import script from "./videoCenter.vue?vue&type=script&lang=js"
export * from "./videoCenter.vue?vue&type=script&lang=js"
import style0 from "./videoCenter.vue?vue&type=style&index=0&id=c2705732&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2705732",
  null
  
)

export default component.exports